import { Component, OnInit } from '@angular/core';
import { VolunteerSubsriptionService } from '../../Services/volunteerSubscription.service';
import { AuthService } from '../../Services/auth.service';
import Swal from 'sweetalert2';
import { Response } from '@angular/http';
import { IMyDayLabels, IMyDpOptions, IMyMarkedDate } from 'mydatepicker';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-volunteer-subscription-admin',
  template: require('./volunteer-subscription-admin.component.html'),
  styles: [require('./volunteer-subscription-admin.component.css')]
})
export class VolunteerSubscriptionAdminComponent implements OnInit {
  
  subscriptionYears: any=[]
  currentYear = new Date().getFullYear();
  loading: boolean = false;
  AllActivities: any = [];

  newSubject: string = '';
  newDescription: string ='';
  newOpen: boolean = false;
  newAllowRemarks:boolean = true;
  editId:number = 0;

  mailBodyHtml:string='';

  newActivity:any = {
    id : -1,
    beginDate : "",
    endDate : "",
    subject : "",
    description : "",
    open : false,
    allowRemarks : true
  };

  selectedBeginDate: any;
  selectedEndDate: any;
  myDatePickerOptions: IMyDpOptions = {
    todayBtnTxt: 'Vandaag',
    dateFormat: 'dd/mm/yyyy',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    markCurrentDay: true,
    height: '34px',
    width: '210px',
    alignSelectorRight: false,
    openSelectorTopOfInput: false,
    indicateInvalidDate: true,
    monthSelector: true,
    yearSelector: true,
    minYear: 1920,
    maxYear: 2200,
    componentDisabled: false,
    editableDateField:false,
    showClearDateBtn: true,
    showDecreaseDateBtn: false,
    showIncreaseDateBtn: false,
    showSelectorArrow: true,
    showInputField: true,
    openSelectorOnInputClick: false,
    disableHeaderButtons: true,
    showWeekNumbers: false,
    markDates: [],
    satHighlight: false,
    highlightDates: [],
    markWeekends: <IMyMarkedDate>{},
    monthLabels: {
        1: 'Januari',
        2: 'Februari',
        3: 'Maart',
        4: 'April',
        5: 'Mei',
        6: 'Juni',
        7: 'July',
        8: 'Augustus',
        9: 'September',
        10: 'Oktober',
        11: 'November',
        12: 'December'
    },
    dayLabels: <IMyDayLabels>{
      su: 'zo', mo: 'ma', tu: 'di', we: 'wo', th: 'do', fr: 'vr', sa: 'za'
    },
    allowDeselectDate: true,
    disableWeekdays: [],
    allowSelectionOnlyInCurrentMonth: true
  };

  constructor(private volunteerSubsriptionService: VolunteerSubsriptionService, private auth: AuthService) { }

  ngOnInit() {
    this.loadAllYearsOfSubscriptions()
    this.loadAllSubscriptionsForYear()
    // this.volunteerSubsriptionService.getAllVolunteerActivities().subscribe( (res:any)=>{
    //   console.log(res);
      
    // } )
  }

  newVolunteerActivityReset(){
    // console.log("new VolunteerActity button");
    this.selectedBeginDate = {};
    this.selectedEndDate = {};
    this.newDescription ='';
    this.editId = 0;
    this.mailBodyHtml = "";
  }

  loadAllYearsOfSubscriptions(){
    this.volunteerSubsriptionService.getAllYearsOfVolunteerActivity().subscribe ( res => {
      if (res.status == 200){
        this.subscriptionYears = res.value
      }
    })
  }

  loadAllSubscriptionsForYear(){
    this.loading = true;
    this.volunteerSubsriptionService.getAllVolunteerActivitiesByYear(this.currentYear).subscribe( res => {
      if (res.status == 200){
        this.AllActivities = res.value;
      }
      this.loading = false;
    })
  }

  yearSelected(){
    this.loadAllSubscriptionsForYear()    
  }

  switchClosed(id: number, open: boolean) {
    this.volunteerSubsriptionService.changeClosedActivity(id, open).subscribe(res => {
      // console.log("Change closed");
      
      // console.log(res);
      
      if (res.status == 200) {
        var subs = this.AllActivities.find((e: any) => e.id == id)
        subs.open = open
      }
    })

  }

  CopyLinkToClipboard(id:number){
    var cpLink = window.location.origin;

    cpLink += '/subscription/volunteers/'+id

    // console.log(cpLink);
    
  
    let anyNavigator: any;
    anyNavigator = window.navigator;
    anyNavigator.clipboard.writeText(cpLink);
    Swal.fire({
      text: "Link gekopieerd naar het clipboard",
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Ok',
    })
  }

  delete(id: number) {
    Swal.fire({
            title: 'Ben je zeker?',
            text: "Ben je zeker dat je deze activiteit wil verwijderen?",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Jep',
            cancelButtonText: 'Nope'
          }).then((result) => {
            if (result.value) {
              this.volunteerSubsriptionService.deleteActivity(id).subscribe(x => {
                this.loadAllSubscriptionsForYear();
              })
            }
          });
  }

  SaveVolunteerActivity(){
    this.newActivity.beginDate =  String(this.selectedBeginDate.date.year)+"-"+String(this.selectedBeginDate.date.month)+"-"+String(this.selectedBeginDate.date.day);
    this.newActivity.endDate = String(this.selectedEndDate.date.year)+"-"+String(this.selectedEndDate.date.month)+"-"+String(this.selectedEndDate.date.day);
    this.newActivity.subject = this.newSubject;
    this.newActivity.description =this.newDescription;
    this.newActivity.open = false;
    this.newActivity.allowRemarks = this.newAllowRemarks;
    this.newActivity.mailBodyHtml = this.mailBodyHtml;
 
  
    if (this.editId > 0){
      this.newActivity.id = this.editId;
      this.volunteerSubsriptionService.updateActivity(this.newActivity).subscribe( (res:any) => {
        this.loadAllSubscriptionsForYear();
        
      })
      
    }else{
      this.volunteerSubsriptionService.createNewActivity(this.newActivity).subscribe( (res:any) => {
        // console.log(res);
        
        this.loadAllSubscriptionsForYear();
      });
    }
  }

  EditVolunteerActivity(id:number){
    var s = this.AllActivities.find( (s:any) => s.id == id)
    // console.log(s)
    var bd = new Date(s.beginDate);
    this.selectedBeginDate = {
      jsdate: bd,
      date:{year: bd.getFullYear(), month: bd.getMonth() +1, day: bd.getDate()}
    };

    var ed = new Date(s.endDate);
    this.selectedEndDate = {
      jsdate: ed,
      date:{year: ed.getFullYear(), month: ed.getMonth() +1, day: ed.getDate()}
    };  
    
    
    this.newSubject = s.subject;
    this.newDescription = s.description;
    this.editId = s.id;  
    this.newAllowRemarks = s.allowRemarks;
    this.mailBodyHtml = s.mailBodyHtml;
    
  }

  DownloadVolunteerSubscription(id: number){
    this.volunteerSubsriptionService.downloadExcel(id).subscribe((res: Response) => {
      if (res.headers) {
        if (res.headers) {
          var header = "";
          header = res.headers.get('content-disposition') || "";
          var startIndex = header.indexOf("filename=") + 9; // Adjust '+ 9' if filename is not the right one.
          var endIndex = header.indexOf(";", startIndex);
          var filename = header.substring(startIndex, endIndex);
          // console.log("filename: " + filename)
          saveAs(res.blob(), filename);
        }
      }
    });
  }
 
 
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/volunteer-subscription-admin/volunteer-subscription-admin.component.ts